import { Trans } from 'react-i18next'
import { AnimatedCountryRate } from '@/components/AnimatedCountryRate'
import type { CountryRate } from '@/types/pricing'

interface HeroDescriptionProps {
  popularCountries: CountryRate[]
}

// Component for highlighted text with background effect
function HighlightedText({ children, variant = 0 }: { children?: React.ReactNode; variant?: number }) {
  const polygons = [
    'polygon(2% 8%, 98% 3%, 99% 92%, 1% 95%)',
    'polygon(1% 5%, 97% 6%, 98% 94%, 2% 93%)',
    'polygon(3% 6%, 99% 4%, 97% 93%, 2% 96%)'
  ];
  const skews = [
    { x: -2, y: -1 },
    { x: 1.5, y: -0.5 },
    { x: -1, y: 1 }
  ];
  
  const safeVariant = variant % 3;
  
  return (
    <span className="relative inline-block font-semibold text-foreground px-2 py-0.5">
      <span 
        className="absolute inset-0 bg-primary/20"
        style={{
          clipPath: polygons[safeVariant],
          transform: `skewX(${skews[safeVariant].x}deg) skewY(${skews[safeVariant].y}deg) scaleY(1.1)`
        }} 
      />
      <span className="relative">{children}</span>
    </span>
  );
}

export function HeroDescription({ popularCountries }: HeroDescriptionProps) {
  return (
    <p className="text-xl md:text-2xl text-muted-foreground mb-8 max-w-3xl mx-auto lg:mx-0 lg:max-w-[50%]">
      <Trans
        i18nKey="hero.description" ns="marketing"
        components={{
          hl1: <HighlightedText variant={0} />,
          hl2: <HighlightedText variant={1} />,
          rate: <AnimatedCountryRate countries={popularCountries} />,
        }}
      />
    </p>
  )
}
